import { render, staticRenderFns } from "./r-trigger-tutorial.vue?vue&type=template&id=cadb7a40&scoped=true"
import script from "./r-trigger-tutorial.vue?vue&type=script&lang=js"
export * from "./r-trigger-tutorial.vue?vue&type=script&lang=js"
import style0 from "./r-trigger-tutorial.vue?vue&type=style&index=0&id=cadb7a40&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cadb7a40",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cadb7a40')) {
      api.createRecord('cadb7a40', component.options)
    } else {
      api.reload('cadb7a40', component.options)
    }
    module.hot.accept("./r-trigger-tutorial.vue?vue&type=template&id=cadb7a40&scoped=true", function () {
      api.rerender('cadb7a40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/trigger/r-trigger-tutorial.vue"
export default component.exports